import { render, staticRenderFns } from "./AgentAdd.vue?vue&type=template&id=db22b388&"
import script from "./AgentAdd.vue?vue&type=script&lang=js&"
export * from "./AgentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports